(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/pages/bankid/components/bankid-start.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/pages/bankid/components/bankid-start.js');

'use strict';

const {
  ReactButton: Button
} = svs.ui;
const Bank = svs.ui.ReactBank;
const {
  useHistory
} = ReactRouterDOM;
const {
  route,
  authMethod
} = svs.playerLogin.constants;
const {
  saveRefForGUITest
} = svs.playerLogin.sharedComponents.sharedUtils;
const {
  getBankIdAutoStartTokenAsync
} = svs.playerLogin.bankid.BankidService;
const {
  useUrlHelper
} = svs.playerLogin.sharedComponents;

const BankIdStart = _ref => {
  let {
    isLogin,
    setPreFetchedAst
  } = _ref;
  const history = useHistory();
  const isStandardMobile = svs.core.detect.formfactor.mobile();
  const lplMethod = ReactRedux.useSelector(state => state.playerloginreact.bankIdLoginMethod);
  const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;
  const isIosNotNative = svs.core.detect.os.iOS() && !isNativeApp;
  const baseUrl = ReactRedux.useSelector(state => state.playerloginreact.baseUrl);
  const {
    navigateToCancelUrl,
    getBankIdAppUrl
  } = useUrlHelper();
  const onBankIdThisDeviceClick = async () => {
    if (isIosNotNative) {
      if (isLogin) {
        window.history.replaceState({}, '', baseUrl + route.LOGIN_BANKID_POLL_APP_ROUTE);
      } else {
        window.history.replaceState({}, '', baseUrl + route.REGISTRATE_BANKID_POLL_APP_ROUTE);
      }

      const {
        autoStartToken: ast
      } = await getBankIdAutoStartTokenAsync(null);

      saveRefForGUITest(ast);

      const appUrl = getBankIdAppUrl(ast);

      setPreFetchedAst(ast);

      svs.utils.url.navigate(appUrl);
    } else if (isLogin) {
      history.push(route.LOGIN_BANKID_POLL_APP_ROUTE);
    } else {
      history.push(route.REGISTRATE_BANKID_POLL_APP_ROUTE);
    }
  };
  const onBankIdOtherDeviceClick = () => {
    if (isLogin) {
      history.push(lplMethod === authMethod.QR ? route.LOGIN_BANKID_POLL_QR_ROUTE : route.LOGIN_BANKID_POLL_SSN_ROUTE);
    } else {
      history.push(lplMethod === authMethod.QR ? route.REGISTRATE_BANKID_POLL_QR_ROUTE : route.REGISTRATE_BANKID_POLL_SSN_ROUTE);
    }
  };
  return React.createElement(React.Fragment, null, isStandardMobile && React.createElement("div", {
    className: "margin-xs-top-4"
  }, React.createElement(Button, {
    block: true,
    iconPosition: "left",
    onClick: onBankIdThisDeviceClick,
    size: 300
  }, React.createElement(Bank, {
    className: "align-left",
    name: "bankid-promo",
    size: 24
  }), isLogin ? 'Logga in' : 'Bli kund')), !isStandardMobile && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "margin-xs-top-4"
  }, React.createElement(Button, {
    block: true,
    iconPosition: "left",
    onClick: onBankIdThisDeviceClick,
    size: 300
  }, React.createElement(Bank, {
    className: "align-left",
    name: "bankid-promo",
    size: 24
  }), "BankID p\xE5 denna enhet")), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement(Button, {
    block: true,
    iconPosition: "left",
    onClick: onBankIdOtherDeviceClick,
    size: 300
  }, React.createElement(Bank, {
    className: "align-left",
    name: "bankid-promo",
    size: 24
  }), "BankID p\xE5 annan enhet"))), React.createElement("div", {
    className: "margin-xs-top-2"
  }, React.createElement(Button, {
    block: true,
    inverted: true,
    onClick: navigateToCancelUrl,
    size: 300,
    transparent: true
  }, "Avbryt")));
};
svs.playerLogin.bankid.components.BankIdStart = BankIdStart;

 })(window);